import { COMPANY_ADMIN, LOAN_CHANNEL_CONSTANTS } from "./common-constants";

export const selectedUserWithLoanChannel = (
	userDetails = {},
	impersonatedUser = {},
	selectedOrganization = ""
) => {
	const resolveChannel = (user) => {
		const channel = user?.loan_channel;
		if (!channel) return user;
		if (Array.isArray(channel)) {
			const matchedOrg = userDetails?.organizations?.find(
				(org) => org.name === selectedOrganization
			);
			return {
				...user,
				loan_channel: matchedOrg?.loan_channel || channel[0],
			};
		}
		return user;
	};

	if (impersonatedUser?.email && impersonatedUser?.loan_channel) {
		return resolveChannel(impersonatedUser);
	} else if (userDetails?.loan_channel) {
		return resolveChannel(userDetails);
	} else {
		return {};
	}
};

// DirectPath Processing is offered to the entire Commercial Broker channel,
// there is no company level eligibility flag.
export const isCommercialBrokerChannel = (
	userDetails = {},
	impersonatedUser = {},
	selectedOrganization = ""
) =>
	selectedUserWithLoanChannel(userDetails, impersonatedUser, selectedOrganization)
		?.loan_channel === LOAN_CHANNEL_CONSTANTS.CB;

export const selectedUserWithAccessLevel = (
	userDetails = {},
	impersonatedUser = {}
) => {
if (impersonatedUser?.email && impersonatedUser?.access_level) {
		return impersonatedUser;
	} else if (userDetails?.access_level) {
		return userDetails;
	} else {
		return {};
	}
};

export const selectedUser = (userDetails = {}, impersonatedUser = {}) => {
	if (impersonatedUser?.email) {
		return impersonatedUser;
	} else if (userDetails?.email) {
		return userDetails;
	} else {
		return {};
	}
};

// Company Admin gates company level settings such as Credit Reissue Configuration.
// It comes from the Encompass TPO Administration persona and is its own access_level,
// separate from the broker admin access level.
export const isCompanyAdmin = (userDetails = {}, impersonatedUser = {}) =>
	selectedUserWithAccessLevel(userDetails, impersonatedUser)?.access_level ===
	COMPANY_ADMIN;

// Values written to Encompass TPO.X61 (LO name) / TPO.X74 (LP name) must never
// be blank or a stringified-undefined value such as "undefined undefined".
export const isInvalidLoLpName = (name) => {
	if (name === null || name === undefined) {
		return true;
	}

	const normalized = String(name).trim().toLowerCase();

	return (
		normalized === "" ||
		normalized === "null" ||
		normalized === "null null" ||
		normalized.includes("undefined")
	);
};

export const buildLoLpFullName = (broker) =>
	`${broker?.user?.first_name ?? ""} ${broker?.user?.last_name ?? ""}`.trim();

// Multi upload rows are keyed by a numeric row id, so only numeric keys count
// when working out which ids a page has already handed out.
export const numericKeys = (source) =>
	Object.keys(source || {})
		.map(Number)
		.filter((key) => Number.isFinite(key));

// Find a broker in a list by id (type-agnostic) with an email fallback.
export const resolveBrokerFromList = (list, brokerId, email) => {
	if (!Array.isArray(list) || list.length === 0) {
		return undefined;
	}

	if (brokerId !== null && brokerId !== undefined && brokerId !== "") {
		const matchById = list.find(
			(item) => String(item?.broker_id) === String(brokerId)
		);

		if (matchById) {
			return matchById;
		}
	}

	const normalizedEmail = String(email || "")
		.trim()
		.toLowerCase();

	if (normalizedEmail === "") {
		return undefined;
	}

	return list.find(
		(item) => String(item?.user?.email || "").toLowerCase() === normalizedEmail
	);
};
